import React from 'react';
import {BasicFieldCheckbox, BasicTextArea, BaasicFormControls, BaasicButton} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import PropTypes from 'prop-types';
import { toUTCDate, isNikoFlowTask } from 'core/utils';

function OrderingTaskEditTemplate ({ orderingTaskEditView, t }) {
    const { form, item,  task, userRoles, modalParams, orderingDate, dateOfService, deliveryDate, openPickTicket, openNikoFacilityOrder, downloadNikoPickTicketExcel } = orderingTaskEditView;
    const hasNikoFlowFacilityOrder = isNikoFlowTask(item && item.facility, dateOfService) && item.facilityOrder && item.facilityOrder.id && !item.isWoundCare;

    return (
        <React.Fragment>
            <div className="modal__header">
                <h3 className='modal__header__title'>
                    {task.name}
                    {hasNikoFlowFacilityOrder &&
                        <a title={t('SCHEDULE.CALENDAR.EDIT.ACCESS_FACILITY_ORDER')}
                            className="u-mar--left--sml u-cursor--pointer"
                            onClick={() => openNikoFacilityOrder(item.facilityOrder.id)}>
                            <i className="u-icon u-icon--package--grey u-icon--sml"></i>
                        </a>
                    }
                    {hasNikoFlowFacilityOrder && item.facilityOrder.sendOrder &&
                        <a title="Download Excel Pick Ticket"
                            className="u-mar--left--sml u-cursor--pointer"
                            onClick={() => downloadNikoPickTicketExcel(item.facilityOrder.id)}>
                            <i className="u-icon u-icon--download u-icon--sml"></i>
                        </a>
                    }
                </h3>
            </div>
            <div className="row">
                    <div className="form__group col col-lrg-4">
                        Ordering Date: { orderingDate ? toUTCDate(orderingDate) : "-" }
                    </div>
                    <div className="form__group col col-lrg-4">
                        Date of service: { dateOfService ? toUTCDate(dateOfService) : "-" }
                    </div>
                    <div className="form__group col col-lrg-4">
                        Delivery Date: { deliveryDate ? toUTCDate(task.date) : "-"}
                    </div>
            </div>
            {task.noSupply && 
                <h4 className="type--center type--color--warning type--wgt--bold u-mar--bottom--sml">
                    {t('SCHEDULE.CALENDAR.EDIT.NOSUPPLY_LABEL')}
                </h4>
            }
            <div className="row">
                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                    <BasicFieldCheckbox field={form.$('isDone')} />
                </div>
                {
                    !isNikoFlowTask(item && item.facility, dateOfService) && item && item.facilityOrder && item.facilityOrder.id && item.facilityOrder.pickTicketHeaderId && !item.isWoundCare && item.facilityOrder.sendOrder &&
                    <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                        <span className='type--wgt--regular u-cursor--pointer' onClick={()=> openPickTicket(item.facilityOrder, item.facilityOrder.pickTicketHeaderId)}>
                            <u>Pick Ticket</u>
                        </span>
                    </div>
                }
            </div>

            {!userRoles.includes("Purchasers") && task.isDone === false && task.noSupply === false &&
                <div className="form__group">
                    <BasicTextArea field={form.$('notes')} />
                </div>
            }

            <div className="form__group">
                <BasicTextArea field={form.$('orderingDetailNote')} />
            </div>
            <div className="form__group">
                <BasicFieldCheckbox field={form.$('isOrderDone')} />
            </div>

            {form.$('isOrderDone').value &&
                <div className="form__group">
                    <BasicTextArea field={form.$('backorderNote')} />
                </div>
            }

            <div className="modal__footer is-right">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save"  className='btn btn--med btn--primary' />  
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </React.Fragment>
    )
}

OrderingTaskEditTemplate.propTypes = {
    orderingTaskEditView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(OrderingTaskEditTemplate);